"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.PropertyBoard = void 0;

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _initializerDefineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/initializerDefineProperty"));

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _assertThisInitialized2 = _interopRequireDefault(require("@babel/runtime/helpers/assertThisInitialized"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _applyDecoratedDescriptor2 = _interopRequireDefault(require("@babel/runtime/helpers/applyDecoratedDescriptor"));

var _initializerWarningHelper2 = _interopRequireDefault(require("@babel/runtime/helpers/initializerWarningHelper"));

var _vuePropertyDecorator = require("vue-property-decorator");

var _stores = require("../stores");

var _vueJsonView = require("vue-json-view");

require("./index.less");

var _langSetting = require("../langSetting");

var _validatorModal = require("../validatorModal");

var _linkForm = require("../linkForm");

var _linkTableProperty = require("../linkTable/linkTableProperty");

var _dec, _dec2, _dec3, _dec4, _class, _class2, _descriptor, _descriptor2, _temp;

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { (0, _defineProperty2.default)(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = (0, _getPrototypeOf2.default)(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = (0, _getPrototypeOf2.default)(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return (0, _possibleConstructorReturn2.default)(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

var PropertyBoard = (_dec = (0, _vuePropertyDecorator.Component)({
  components: {
    LangSetting: _langSetting.LangSetting,
    ValidatorModal: _validatorModal.ValidatorModal,
    LinkFormProperty: _linkForm.LinkFormProperty,
    LinkTableProperty: _linkTableProperty.LinkTableProperty
  }
}), _dec2 = (0, _vuePropertyDecorator.Prop)({
  default: function _default() {
    return [];
  }
}), _dec3 = (0, _vuePropertyDecorator.Prop)({
  default: 'zh'
}), _dec4 = (0, _vuePropertyDecorator.Watch)('defaultLang', {
  immediate: true
}), _dec(_class = (_class2 = (_temp = /*#__PURE__*/function (_Vue) {
  (0, _inherits2.default)(PropertyBoard, _Vue);

  var _super = _createSuper(PropertyBoard);

  function PropertyBoard() {
    var _this;

    (0, _classCallCheck2.default)(this, PropertyBoard);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _super.call.apply(_super, [this].concat(args));
    (0, _initializerDefineProperty2.default)(_this, "otherLangList", _descriptor, (0, _assertThisInitialized2.default)(_this));
    (0, _initializerDefineProperty2.default)(_this, "defaultLang", _descriptor2, (0, _assertThisInitialized2.default)(_this));
    _this.cache = {};
    _this.store = _stores.store;
    return _this;
  }

  (0, _createClass2.default)(PropertyBoard, [{
    key: "propertyList",
    get: function get() {
      var otherLangList = this.otherLangList,
          defaultLang = this.defaultLang,
          cache = this.cache;
      var currentField = this.store.currentField;
      var setLangList = [];
      var propertyList = (currentField && currentField.property || []).filter(function (property) {
        // 过滤隐藏属性
        if (property._show) {
          return _vueJsonView.Utils.transText(property._show, currentField && currentField.component);
        }

        return true;
      }).map(function (property) {
        // 提取多语言字段
        if (property._langProperty) {
          setLangList.push(property);
          return _objectSpread(_objectSpread({}, property), {}, {
            name: "_lang.".concat(defaultLang, ".").concat(property.name)
          });
        }

        return property;
      }); // 添加多语言设置

      if (setLangList.length > 0) {
        otherLangList.forEach(function (lang) {
          propertyList.push({
            tag: 'mh-form-item',
            name: "_lang.".concat(lang.value),
            label: "".concat(lang.label),
            children: [{
              tag: 'lang-setting',
              propertyList: setLangList
            }]
          });
        });
      }

      return propertyList;
    }
  }, {
    key: "defaultLangChange",
    value: function defaultLangChange(lang) {
      this.store.defaultLang = lang;
    }
  }, {
    key: "onItemChange",
    value: function onItemChange(values) {
      var currentField = this.store.currentField;

      if (currentField && currentField.dragComponent) {
        currentField.dragComponent = _vueJsonView.Utils.setDataByObj(currentField.dragComponent, values);
      }

      if (currentField && currentField.component) {
        currentField.component = _vueJsonView.Utils.setDataByObj(currentField.component, values);
      }
    }
  }, {
    key: "render",
    value: function render(h) {
      var propertyList = this.propertyList;
      var currentField = this.store.currentField;
      return h("div", {
        "class": "property-board"
      }, [currentField ? h("mh-form", {
        "key": currentField.uid,
        "attrs": {
          "layout": "vertical",
          "initData": currentField.component
        },
        "on": {
          "itemChange": this.onItemChange
        }
      }, [propertyList.map(function (p) {
        return _vueJsonView.VueJsonView.ele2VNode(h, _objectSpread(_objectSpread({}, p), {}, {
          key: p.name
        }));
      })]) : h("div", ["\u8BF7\u9009\u62E9\u4E00\u4E2A\u5B57\u6BB5\u6765\u8BBE\u7F6E\u5C5E\u6027"])]);
    }
  }]);
  return PropertyBoard;
}(_vuePropertyDecorator.Vue), _temp), (_descriptor = (0, _applyDecoratedDescriptor2.default)(_class2.prototype, "otherLangList", [_dec2], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor2 = (0, _applyDecoratedDescriptor2.default)(_class2.prototype, "defaultLang", [_dec3], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), (0, _applyDecoratedDescriptor2.default)(_class2.prototype, "defaultLangChange", [_dec4], Object.getOwnPropertyDescriptor(_class2.prototype, "defaultLangChange"), _class2.prototype)), _class2)) || _class);
exports.PropertyBoard = PropertyBoard;